<template>
  <div class="basic-block block-mokuji" :style="styles">
    <div class="content-wrap">
      <div class="block-mokuji__inner">
        <div class="block-mokuji__title">もくじ</div>
        <ul class="block-mokuji__list">
          <li v-for="(v, i) in list" :key="i">{{ v }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockMokuji',
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
  },
  data() {
    return {
      list: [
        `■${this.resultData.text2}タイプのラッキーカラー`,
        `■${this.resultData.text2}タイプと仕事相性がいい鳳凰タイプは？`,
        `■${this.resultData.text2}タイプとぶつかりがちな鳳凰タイプは？`,
        `■あなたへのアドバイス`,
      ],
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-mokuji {
  background: #FFFBE3;
  padding: 0 0 56px;
  &__inner {
    margin: 0 20px;
    padding: 28px 20px 24px;
    background: #fff;
    position: relative;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      right: 0;
      width: 50%;
      height: 36px;
      background: linear-gradient(to right bottom, #fff 50%, transparent 50% );
    }
    &::after {
      left: 0;
      right: unset;
      background: linear-gradient(to left bottom, #fff 50%, transparent 50% );
    }
  }
  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: justify;
    letter-spacing: -0.5px;
    color: $l_col_keycolor;
  }
  &__list {
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    letter-spacing: -0.5px;
    color: $l_col_keycolor;
    padding: 0;
    margin: 0;
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockMokuji.vue